/**
 * Query-key factory for the financial-aids slice. A stable ``all`` root lets a
 * favorite mutation invalidate the whole subtree after a write. The directory /
 * detail keys carry the action so a different action is cached separately.
 */
export const financialAidKeys = {
  all: ["financial-aids"] as const,
  directory: (action: string | null) =>
    [...financialAidKeys.all, "directory", action ?? "none"] as const,
  directorySectors: () =>
    [...financialAidKeys.all, "directory-sectors"] as const,
  detail: (action: string | null, id: string) =>
    [...financialAidKeys.all, "detail", action ?? "none", id] as const,
  favorites: (action?: string | null) =>
    [...financialAidKeys.all, "favorites", action ?? "all"] as const,
  admin: () => [...financialAidKeys.all, "admin"] as const,
  adminList: () => [...financialAidKeys.admin(), "list"] as const,
  adminDetail: (id: string) => [...financialAidKeys.admin(), "detail", id] as const,
  adminCatalog: () => [...financialAidKeys.admin(), "action-catalog"] as const,
  adminTerritories: () => [...financialAidKeys.admin(), "territories"] as const,
  adminHistory: (id: string | null) =>
    [...financialAidKeys.admin(), "history", id ?? "none"] as const,
  adminLinkChanges: () => [...financialAidKeys.admin(), "link-changes"] as const,
  adminLinkChange: (id: string) =>
    [...financialAidKeys.admin(), "link-change", id] as const,
  adminActionOrder: (actionId: string) =>
    [...financialAidKeys.admin(), "action-order", actionId] as const,
} as const;
